<template>
  <div>
    <div class="related-transaction-container">
      <div
        class="is-flex is-justify-content-space-between p-2 mb-2 related-transaction-details">
        <div class="is-flex is-flex-direction-column related-transaction-content last">
          <span class="is-size-4 has-text-primary">{{ $t('transactions.transactionAmount') }}</span>
        </div>
        <div class="is-flex is-flex-direction-column related-transaction-content last">
          <span v-if="transaction.amount > 0" class="has-text-weight-semibold is-size-4">{{ formatNumberByCountry(transaction.amount) }}</span>
          <div v-if="transaction.usedClientBalance > 0" class="is-size-7 mt-2">
            <b-tag rounded type="is-primary is-light">
              {{ $t('transactions.usedClientBalance') }}:
              <span class="has-text-weight-semibold">{{ formatNumberByCountry(transaction.usedClientBalance) }}</span>
            </b-tag>
          </div>
        </div>
      </div>
      <div
        v-for="operation in transaction.selectedPayments"
        :key="operation.operationId">
        <div
          class="is-flex is-justify-content-space-between p-2 mb-3 related-transaction-details">
          <div class="is-flex is-flex-direction-column related-transaction-content">
            <span class="is-size-6 has-text-primary">{{ $t('generalWords.Operation') }}</span>
            <span class="has-text-weight-semibold has-text-grey">
              <b-tooltip type="is-primary is-light" :label="getOperationTypeTitle(operation.type)" dashed>
                {{ operation.companyOperationId }}
              </b-tooltip>
            </span>
          </div>
          <div class="is-flex is-flex-direction-column related-transaction-content last">
            <span class="is-size-6 has-text-primary">{{ $t('generalWords.Amount') }}</span>
            <span
              v-for="payment in operation.payments"
              :key="`${operation.operationId}-${payment.paymentNumber}`"
              class="has-text-weight-medium has-text-grey mb-1">
              {{ formatNumberByCountry(payment.secondaryCurrencyTotalMonthlyPayment || payment.totalMonthlyPayment) }}
              <b-tag rounded type="is-primary is-light" class="has-text-weight-light mx-1">{{ $t('generalWords.Payment') }} {{ payment.paymentNumber }}</b-tag>
            </span>
            <div v-if="operation.payments.length > 1">
              <div class="has-text-grey is-size-6 mt-4">
                Total {{ $t('generalWords.payments') }}:
                <span class="has-text-weight-semibold">{{ formatNumberByCountry(sumIndividualOperationPayments(operation.payments)) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-notification
      v-if="transaction.provider==='SERVIPAG_BUTTON'"
      type="is-warning"
      aria-close-label="Close message"
      class="servipag-related-transaction-warning m-5">
      <p>Tu pago está siendo procesado, esto puede tomar hasta tres días hábiles.</p>
      <p>Si intentaste pagar con Servipag, pero estás seguro de que tu pago no ocurrió, puedes anularlo y pagar nuevamente.</p>
    </b-notification>
    <div v-if="displayCancelButton !== 'hide'">
      <button
        class="cancel-transaction-button button is-button-primary is-rounded"
        :disabled="displayCancelButton === 'disabled'"
        @click="$emit('open-cancel-transaction-modal', transaction._id)">
        <span>{{ $t('transactions.cancelTransaction') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { formatNumberByCountry } from '@/infrastructure/format';

export default {
  props: ['transaction', 'paymentProviders', 'displayCancelButton'],
  data() {
    return {};
  },
  methods: {
    getOperationTypeTitle(type) {
      return {
        MORTGAGE: `🏡 ${this.$t('generalWords.Mortgage')}`,
        COMPLEMENTARY: `💰 ${this.$t('generalWords.Complementary')}`,
        HOME_EQUITY: `🏡 ${this.$t('generalWords.HomeEquity')}`,
        PARKING: `🅿️ ${this.$t('generalWords.Parking')}`,
        SME: `🚀 ${this.$t('generalWords.Sme')}`
      }[type];
    },
    formatNumberByCountry(number) {
      const fractionDigits = {
        br: 2,
        cl: 0,
        pe: 2
      }[this.$i18n.locale];
      return formatNumberByCountry({ number, countryIn: this.$i18n.locale, usePrefix: true, fractionDigits, currencyType: 'secondary' });
    },
    sumIndividualOperationPayments(payment) {
      return (payment.map(val => {
        return val.secondaryCurrencyTotalMonthlyPayment;
      })).reduce((a, b) => a + b, 0);
    }
  }
};
</script>

<style>
.related-transaction-details {
  flex-direction: row;
  border-bottom: solid 1px rgb(237, 237, 237);
}

.related-transaction-content {
  border-right: solid 1px rgb(237, 237, 237);
  width: 100%;
  margin-left: 1rem;
}

.related-transaction-content.last {
  border-right: none !important;
}

.related-transaction-container {
  container-type: inline-size;
}

@container (max-width: 400px){
  .related-transaction-details {
    flex-direction: column !important;
  }
  .related-transaction-content {
  border-right: none !important;
}
}

@media (max-width: 1160px) {
  .related-transaction-details {
    flex-direction: column !important;
  }

  .related-transaction-content {
    margin-top: 1rem;
  }
}
</style>
